export default {
     namespaced: true,
     state: {
        loadedByPosition: false,
        currentPoints: []
     },
     mutations: {
         setCurrentPoints(state, points) {
             state.currentPoints = points;
         },
         setLoadedByPosition(state) {
             state.loadedByPosition = true;
         }
     },
     actions: {
         setCurrentPoints(context, points) {
             context.commit("setCurrentPoints", points);
         },
         setLoadedByPosition(context) {
             context.commit("setLoadedByPosition");
         }
     },
     getters: {
     }
 }